// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionSearchByIDAPI, searchByIDAPIError, searchByIDAPISuccess, ActionSearchByLabelAPI, searchByLabelAPIError, searchByLabelAPISuccess,ActionConnectDealerToEngineAPI, connectDealerToEngineAPIError, connectDealerToEngineAPISuccess,ActionDisconnectDealerToEngineAPI, disconnectDealerToEngineAPI, disconnectDealerToEngineAPISuccess, disconnectDealerToEngineAPIError } from './actions';
import { SearchResults, Connect } from './types';

import { createAPINetworkInstance } from '../../../../common/api';
import { parseAPISearchResults,parseAPIConnect } from './utils';

function* searchByID(action: ActionSearchByIDAPI) {
    try {
        const { iddealer } = action
        const { data } = yield call(createAPINetworkInstance().post, `engine/GMB/dealer/${iddealer}/connect`);
        const resultSearch: SearchResults = parseAPISearchResults(data);
        yield put(searchByIDAPISuccess(resultSearch));
    } catch (err) {
        yield put(searchByIDAPIError());
    }
}

function* searchByLabel(action: ActionSearchByLabelAPI) {
    try {
        const { iddealer, label } = action
        const { data } = yield call(createAPINetworkInstance().get, `engine/GMB/dealer/${iddealer}/locations?name=${label}`);
        const resultSearch: SearchResults = parseAPISearchResults(data);
        yield put(searchByLabelAPISuccess(resultSearch));
    } catch (err) {
        yield put(searchByLabelAPIError());
    }
}

function* connectDealerToEngine(action: ActionConnectDealerToEngineAPI) {
    try {
        const { idengine, iddealer, idbusinessacount } = action
        const { data } = yield call(createAPINetworkInstance().post, `engine/${idengine}/dealer/${iddealer}/businessacount/${idbusinessacount}`);
        const connection: Connect = parseAPIConnect(data);
        yield put(connectDealerToEngineAPISuccess(connection));
    } catch (err) {
        yield put(connectDealerToEngineAPIError());
    }
}

function* disconnectDealerToEngine(action: ActionDisconnectDealerToEngineAPI) {
    try {
        const { idengine, iddealer } = action
        const { data } = yield call(createAPINetworkInstance().post, `engine/${idengine}/dealer/${iddealer}/disconnect`);
        const connection: Connect = parseAPIConnect(data);
        yield put(disconnectDealerToEngineAPISuccess(connection));
    } catch (err) {
        yield put(disconnectDealerToEngineAPIError());
    }
}


export default function* connectByLabelSagas() {
    yield takeLatest(ACTIONS.SEARCHING_BY_ID_API_REQUEST, searchByID);
    yield takeLatest(ACTIONS.SEARCHING_BY_LABEL_API_REQUEST, searchByLabel);
    yield takeLatest(ACTIONS.CONNECT_DEALER_TO_ENGINE_API_REQUEST, connectDealerToEngine);
    yield takeLatest(ACTIONS.DISCONNECT_DEALER_TO_ENGINE_API_REQUEST, disconnectDealerToEngine);
}
